// src/pages/Newsletters/CreateNewsletterModal.jsx
import React, { useState } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import { addNewsletter } from "./../../services/newsletterServices";
import Button from "./../../components/Button/Button";
import { toast } from "react-toastify";

const moisOptions = [
  "JANVIER",
  "FÉVRIER",
  "MARS",
  "AVRIL",
  "MAI",
  "JUIN",
  "JUILLET",
  "AOÛT",
  "SEPTEMBRE",
  "OCTOBRE",
  "NOVEMBRE",
  "DÉCEMBRE",
];

const CreateNewsletterModal = ({ isOpen, onClose, refreshList }) => {
  const currentYear = new Date().getFullYear();

  const [formData, setFormData] = useState({
    annee_newsletter: currentYear.toString(),
    mois_newsletter: "",
    lien_newsletter: "",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addNewsletter(formData);
      await refreshList();
      onClose();
      toast.success("Newsletter créée avec succès");
      setFormData({
        annee_newsletter: currentYear.toString(),
        mois_newsletter: "",
        lien_newsletter: "",
      });
    } catch (error) {
      console.error("Erreur lors de la création de la newsletter", error);
      toast.error("Erreur lors de la création de la newsletter");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="w-full max-w-md bg-white dark:bg-slate-900 dark:text-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary via-indigo-500 to-cyan-500 px-5 py-3 flex items-center justify-between">
          <h3 className="text-lg font-bold uppercase text-white tracking-[0.18em]">
            Créer une Newsletter
          </h3>
          <button
            type="button"
            onClick={handleCancel}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-black/40 text-white hover:bg-black/70"
          >
            <FaTimes />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label
              className="block text-xs font-semibold mb-1 uppercase tracking-[0.18em] text-slate-600 dark:text-slate-300"
              htmlFor="annee_newsletter"
            >
              Année
            </label>
            <input
              type="number"
              id="annee_newsletter"
              name="annee_newsletter"
              placeholder="Ex : 2025"
              value={formData.annee_newsletter}
              onChange={handleChange}
              className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              required
            />
          </div>

          <div>
            <label
              className="block text-xs font-semibold mb-1 uppercase tracking-[0.18em] text-slate-600 dark:text-slate-300"
              htmlFor="mois_newsletter"
            >
              Mois
            </label>
            <select
              id="mois_newsletter"
              name="mois_newsletter"
              value={formData.mois_newsletter}
              onChange={handleChange}
              className="select select-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              required
            >
              <option value="">Sélectionnez un mois</option>
              {moisOptions.map((mois) => (
                <option key={mois} value={mois}>
                  {mois}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              className="block text-xs font-semibold mb-1 uppercase tracking-[0.18em] text-slate-600 dark:text-slate-300"
              htmlFor="lien_newsletter"
            >
              Lien de la Newsletter
            </label>
            <input
              type="url"
              id="lien_newsletter"
              name="lien_newsletter"
              placeholder="https://..."
              value={formData.lien_newsletter}
              onChange={handleChange}
              className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              required
            />
            <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400">
              Lien vers le PDF ou la page en ligne de la newsletter.
            </p>
          </div>

          <div className="flex justify-center gap-3 pt-2">
            <Button
              text="Créer"
              icon={FaSave}
              type="submit"
              className="gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={handleCancel}
              type="button"
              className="gap-2 btn-ghost"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateNewsletterModal;
